// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"d366a24a","326":"d379ec05"}[chunkId] + ".css";
};